module.exports = __webpack_public_path__ + "static/media/ksd.logo.300w.7d916908.png";